function getWidgetContainer() {
  return document.querySelector('[data-solv-chatbot-container]');
}

function getRequestId() {
  const storedRequestId = getStoredRequestId();
  if (storedRequestId) {
    return storedRequestId;
  }
  return getWidgetContainer().dataset.requestId;
}

function getInvalidRequestId() {
  return getWidgetContainer().dataset.invalidRequestId;
}

function getGroupId() {
  return getWidgetContainer().dataset.groupId;
}

function getStoredRequestId() {
  const groupId = getGroupId();
  const key = 'solvChatId' + groupId;

  let idHashInfo = window.localStorage.getItem(key);
  idHashInfo = JSON.parse(idHashInfo);

  if (idHashInfo == null || idHashInfo == undefined) {
    return '';
  }

  const idHashExpired = idHashInfo.expiry < new Date().getTime();

  if (!idHashExpired) {
    return idHashInfo.storedID;
  }

  return '';
}

function getWidgetContent() {
  return document.querySelector('[data-solv-chatbot-content-slot]');
}

function widgetIsClosed() {
  return getWidgetContent().classList.contains('solv-chatbot-widget--hidden');
}

function getMinimizeBtn() {
  return document.querySelector('[data-solv-chatbot-widget-minimize-btn]');
}

function getCloseBtn() {
  return document.querySelector('[data-solv-chatbot-widget-close-btn]');
}

function getMaximizeBtn() {
  return document.querySelector('[data-solv-chatbot-widget-maximize-btn]');
}

function getMessagesElement() {
  return document.querySelector('[data-solv-chatbot-messages]');
}

function getGreetingElement() {
  return document.querySelector('[data-solv-chatbot-greeting]');
}

function getMessageFeed() {
  return document.querySelector('[data-solv-chatbot-message-feed]');
}

function getUserMsgInputField() {
  return document.querySelector('[data-solv-chatbot-message-input]');
}

function getMsgInputForm() {
  return document.querySelector('[data-solv-chatbot-message-form]');
}

function getMsgSendBtn() {
  return document.querySelector('[data-solv-chatbot-user-send]');
}

function getGreetingsButtons() {
  return document.querySelectorAll('[data-solv-chatbot-greetings-button]');
}

function getnewUserForm() {
  return document.querySelector('[data-solv-chatbot-phone-form]');
}

function getFirstNameInput() {
  return document.querySelector('[data-solv-chatbot-first-name-input]');
}

function getLastNameInput() {
  return document.querySelector('[data-solv-chatbot-last-name-input]');
}

function getPhoneNumberInput() {
  return document.querySelector('[data-solv-chatbot-phone-number-input]');
}

function getFirstNameErrorMessage() {
  return document.querySelector('[data-solv-chatbot-user-name-error]');
}

function getLastNameErrorMessage() {
  return document.querySelector('[data-solv-chatbot-user-last-name-error]');
}

function getPhoneNumberErrorMessage() {
  return document.querySelector('[data-solv-chatbot-user-phone-error]');
}

function getButtons() {
  return document.querySelectorAll('[data-solv-chatbot-button]');
}

function getButtonContainers() {
  return document.querySelectorAll('[data-solv-chatbot-buttons]');
}

function getMinMaxButtonContainer() {
  return document.querySelector('[data-solv-chatbot-min-max-btn-container]');
}

function getForms() {
  return document.querySelectorAll('[data-solv-chatbot-form]');
}

function getLoadingDots() {
  return document.querySelector('[data-solv-chatbot-loading-dots]');
}

function getHiddenMessages() {
  return document.querySelectorAll(
    '.solv-chatbot-widget__message-wrapper--hidden',
  );
}

function getTestInformation() {
  let testElment = document.querySelector('[data-chat-bot-test]');
  if (testElment) {
    return true;
  } else {
    return false;
  }
}

function getTimeStampElement() {
  return document.querySelector('[data-solv-chatbot-timestamp]');
}

function getTimeStampElementByIntervalID(id) {
  return document.querySelector(`[data-solv-chatbot-timestamp-id="${id}"]`);
}

function getTimeStampInfoElement(id) {
  const timeStampElement = getTimeStampElementByIntervalID(id);
  if (timeStampElement === null || timeStampElement === undefined) {
    return null;
  }
  return timeStampElement.querySelector('[data-solv-chatbot-timestamp-info]');
}

function setTimeStamp(value, id) {
  const timeStamp = getTimeStampInfoElement(id);
  if (timeStamp) {
    timeStamp.innerHTML = value;
    timeStamp.ariaLabel = value;
  }
}

function setTimeStampIntervalID(newID) {
  const timeStamp = getTimeStampElement();
  if (timeStamp === null || timeStamp === undefined) {
    return;
  }
  timeStamp.dataset.solvChatbotTimestampId = newID;
}

function deleteTimestamp() {
  const timeStamp = getTimeStampElement();
  if (timeStamp) {
    timeStamp.remove();
  }
}

export {
  getMaximizeBtn,
  getMinimizeBtn,
  getWidgetContainer,
  widgetIsClosed,
  getWidgetContent,
  getMessageFeed,
  getUserMsgInputField,
  getMsgInputForm,
  getMsgSendBtn,
  getMessagesElement,
  getGreetingsButtons,
  getButtonContainers,
  getnewUserForm,
  getPhoneNumberInput,
  getFirstNameInput,
  getButtons,
  getLoadingDots,
  getGreetingElement,
  getRequestId,
  getGroupId,
  getHiddenMessages,
  getForms,
  getPhoneNumberErrorMessage,
  getFirstNameErrorMessage,
  getLastNameInput,
  getLastNameErrorMessage,
  getTestInformation,
  getTimeStampElement,
  getTimeStampInfoElement,
  setTimeStamp,
  deleteTimestamp,
  setTimeStampIntervalID,
  getCloseBtn,
  getMinMaxButtonContainer,
  getInvalidRequestId,
};
